import React from 'react';
import { SparklesIcon, UserRoundIcon } from 'lucide-react';
import { useActivityPlan, type Persona } from '../../contexts/ActivityPlanContext';
const personas: {
  id: Persona;
  label: string;
  detail: string;
  icon: typeof UserRoundIcon;
}[] = [{
  id: 'established',
  label: 'Jordan Reyes',
  detail: 'Established plan · activity logged',
  icon: UserRoundIcon
}, {
  id: 'fresh',
  label: 'New officer',
  detail: 'No plan yet · fresh setup',
  icon: SparklesIcon
}];
export function PersonaSwitcher() {
  const {
    persona,
    setPersona
  } = useActivityPlan();
  return <div className="rounded-xl border border-navy-100 bg-navy-50/60 p-2" data-id="element-517" data-mp="rulxb9y522fs">
      <p className="px-1 pb-1.5 text-[11px] font-bold uppercase tracking-wide text-navy-400" data-id="element-518" data-mp="nsij4dk34jqt">
        Demo state
      </p>
      <div role="radiogroup" aria-label="Demo state" className="space-y-1" data-id="element-519" data-mp="238pvytfo8er6">
        {personas.map(item => {
        const active = persona === item.id;
        const Icon = item.icon;
        return <button key={item.id} type="button" role="radio" aria-checked={active} onClick={() => setPersona(item.id)} className={`flex w-full items-center gap-2 rounded-lg px-2 py-2 text-left ${active ? 'bg-white text-navy-900 shadow-card ring-1 ring-brand-200' : 'text-navy-600 hover:bg-white/70'}`} data-id="element-520" data-mp="1dj4iqp4pa252">
              <Icon className={`h-4 w-4 shrink-0 ${active ? 'text-brand-600' : 'text-navy-400'}`} aria-hidden="true" data-id="element-521" data-mp="yv08m9jpqyxw" />
              <span className="min-w-0" data-id="element-522" data-mp="13t1oklluei55">
                <span className="block truncate text-xs font-semibold" data-id="element-523" data-mp="18lmidn4r0v8o">
                  {item.label}
                </span>
                <span className="block truncate text-[11px] text-navy-500" data-id="element-524" data-mp="b4npe2j0pfs0">
                  {item.detail}
                </span>
              </span>
            </button>;
      })}
      </div>
    </div>;
}